import { AttachFile, AttachFileRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { BiTrash } from "react-icons/bi";
import { Download } from "@mui/icons-material";
import { useMutation } from "@tanstack/react-query";
import { getSingedUrlSurveyDoc } from "actions/survey/surveyAction";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";
const DocumentUpload = ({
  submittedAnswer,
  responseAnswer,
  isFrom,
  handleQuesAnswer,
  event,
  comment,
  submittedFiles,
  question,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [commentBox, setCommentBox] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (submittedAnswer?.length > 0) {
      setCommentBox(submittedAnswer?.[0]?.comment || "");
      setSelectedFiles(submittedAnswer?.[0]?.document || []);
    }
  }, []);

  const handleChange = (type, value) => {
    let updatedFiles = selectedFiles;
    let updatedComment = commentBox;

    if (type === "fileAdd") {
      const filesArray = Array.from(value);
      updatedFiles = [...selectedFiles, ...filesArray];
      setSelectedFiles(updatedFiles);

      if (inputRef.current) inputRef.current.value = "";
    } else if (type === "fileDelete") {
      updatedFiles = selectedFiles.filter((_, i) => i !== value);
      setSelectedFiles(updatedFiles);
    } else if (type === "comment") {
      updatedComment = value;
      setCommentBox(value);
    }

    if (isFrom === "taskSection") {
      const obj = {
        document: updatedFiles,
        comment: updatedComment,
        weightage: 1,
        documentMetaData: updatedFiles.map((d) => ({
          ques_id: question?._id,
          name: d?.name,
          is_supporting_document: false,
        })),
      };
      handleQuesAnswer({ obj, realQuestion: question });
    }
  };

  const { mutateAsync } = useMutation({
    mutationFn: getSingedUrlSurveyDoc,
    onSuccess: (data) => {},
    onError: (error) => {
      // Handle error
      console.error("Create failed:", error);
    },
    staleTime: Infinity,
    cacheTime: 0,
  });

  const handleDownload = async (key, file_name) => {
    // const updateDataStructure = transformData(data);

    let response = await mutateAsync({
      key,
    });
    if (response?.status) {
      downloadFile(response?.url, file_name);
    }
    return response;
  };

  const downloadFile = (fileUrl, fileName) => {
    const link = document.createElement("a"); // Create a temporary anchor element
    link.href = fileUrl; // Set the href to the file URL
    link.download = fileName; // Set the desired file name for download
    // link.target = "_blank"
    document.body.appendChild(link); // Append the link to the body (not displayed)
    link.click(); // Programmatically click the link to trigger the download
    document.body.removeChild(link); // Clean up: remove the link
  };

  return (
    <Box
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      {/* Uploaded Files (Editable) */}
      {isFrom === "taskSection" && selectedFiles?.length > 0 && (
        <Box mt={2}>
          {selectedFiles.map((file, index) => (
            <Box
              key={index}
              display="flex"
              alignItems="center"
              gap={2}
              p={1}
              borderColor="#cecece"
            >
              <Box display="flex" alignItems="center" gap={2}>
                <AttachFileRounded
                  style={{ backgroundColor: "#ced4da", padding: 4 }}
                  color="disabled"
                />
                <Typography>{file.name}</Typography>
              </Box>
              <IconButton
                onClick={() => handleChange("fileDelete", index)}
                size="medium"
                color="error"
              >
                <BiTrash />
              </IconButton>
            </Box>
          ))}
        </Box>
      )}

      {/* Upload Button */}
      {(isFrom === "taskSection" ||
        isFrom === "surveyCreation" ||
        isFrom === "publishedSurvey") && (
        <Box
          width="100%"
          style={{
            margin: "26px 5px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => inputRef.current?.click()}
        >
          <AttachFile
            style={{ backgroundColor: "#ced4da", padding: 4 }}
            color="disabled"
          />
          <input
            ref={inputRef}
            type="file"
            multiple
            style={{ display: "none", pointerEvents: event }}
            onChange={(e) => handleChange("fileAdd", e.target.files)}
            disabled={isFrom === "surveyCreation"}
          />
          {(isFrom === "surveyCreation" || isFrom === "publishedSurvey") && (
            <Box
              style={{
                borderBottom: "2px solid #ced4da",
                marginLeft: 20,
                width: "100%",
                fontSize: "14px",
              }}
            >
              Upload file
            </Box>
          )}
          {isFrom !== "surveyCreation" && isFrom !== "publishedSurvey" && (
            <Button variant="outlined" size="small" style={{ marginLeft: 10 }}>
              Add Files
            </Button>
          )}
        </Box>
      )}

      {isFrom !== "taskSection" &&
        isFrom !== "surveyCreation" &&
        isFrom !== "publishedSurvey" &&
        submittedAnswer?.[0]?.document?.length > 0 &&
        submittedAnswer?.[0]?.document.map((doc, i) => (
          <Box
            key={i}
            border={1}
            borderRadius={4}
            p={1}
            borderColor="#cecece"
            mt={2}
            sx={{
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <a
              // href={doc?.url || doc?.key}
              // target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#1976d2",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              {doc?.name}
            </a>
            <Tooltip title="Download">
              <IconButton
                size="small"
                onClick={(e) => {
                  if (doc?.key) {
                    handleDownload(doc?.key, doc?.name);
                  } else {
                    downloadFile(doc?.url, doc?.name);
                  }
                  // e.preventDefault();
                  // e.stopPropagation();
                }}
              >
                <Download fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        ))}

      {/* Comment Box */}
      {comment && (
        <Box
          sx={{
            pointerEvents:
              isFrom === "surveyResponse" || isFrom === "publishedSurvey"
                ? "none"
                : "auto",
          }}
        >
          <AdvancedInputField
            data={commentBox}
            placeholder="Contributor’s comment"
            name="comment"
            handleChange={({ name, value }) => handleChange(name, value)}
          />
        </Box>
      )}
    </Box>
  );
};

export default DocumentUpload;
